// Reports menu in the sidebar, by group. Entries with `report` open the standard report page
// (/reports/<key>, served by the backend report catalog); entries with `name` are older report
// pages with their own route. Each entry is shown only with its permission.
export const REPORT_MENU = [
  {
    group: 'Sales',
    icon: 'trending-up',
    items: [
      { label: 'Sales Report', name: 'salesreport', permission: 'reports.sales.view' },
      { label: 'Business Report', name: 'businessreport', permission: 'reports.sales.view' },
      { label: 'Bill-wise Profit', report: 'bill-profit', permission: 'reports.accounts.view' },
      { label: 'Item-wise Profit', report: 'item-profit', permission: 'reports.accounts.view' },
    ],
  },
  {
    group: 'Purchases',
    icon: 'shopping-bag',
    items: [
      { label: 'Purchase Report', name: 'purchasereport', permission: 'reports.purchase.view' },
    ],
  },
  {
    group: 'Accounts',
    icon: 'book-open',
    items: [
      { label: 'Profit & Loss', report: 'profit-loss', permission: 'reports.accounts.view' },
      { label: 'Day Book', report: 'day-book', permission: 'reports.accounts.view' },
      { label: 'Cash Flow', report: 'cash-flow', permission: 'reports.accounts.view' },
      { label: 'Receivables Ageing', report: 'receivable-ageing', permission: 'reports.accounts.view' },
      { label: 'Payables Ageing', report: 'payable-ageing', permission: 'reports.accounts.view' },
      { label: 'Party Statement', report: 'party-statement', permission: 'reports.accounts.view' },
    ],
  },
  {
    group: 'Inventory',
    icon: 'archive',
    items: [
      { label: 'Stock Report', name: 'inventoryreport', permission: 'reports.stock.view' },
      { label: 'Stock Ledger', name: 'stockledgerreport', permission: 'reports.stock.view' },
      { label: 'Stock Ageing', report: 'stock-ageing', permission: 'reports.stock.view' },
      { label: 'Fast / Slow / Non-moving', report: 'stock-movement', permission: 'reports.stock.view' },
      { label: 'Near Expiry', report: 'near-expiry', permission: 'reports.stock.view' },
    ],
  },
  {
    group: 'GST',
    icon: 'percent',
    items: [
      { label: 'GST Report (GSTR-1 / HSN)', name: 'gstreport', permission: 'reports.tax.view' },
      { label: 'GSTR-3B Summary', report: 'gstr3b', permission: 'reports.tax.view' },
      { label: 'Purchase Register (ITC)', report: 'purchase-register', permission: 'reports.tax.view' },
      { label: 'Credit / Debit Notes', report: 'credit-notes', permission: 'reports.tax.view' },
    ],
  },
];

export function reportMenuTarget(item) {
  return item.report ? { name: 'report-viewer', params: { key: item.report } } : { name: item.name };
}

export function isReportMenuItemActive(item, route) {
  return item.report ? route.name === 'report-viewer' && route.params.key === item.report : route.name === item.name;
}
